import http from "@/axios/http-common";
import { UnitJourneyEnvelope } from "@/types/riwayat";

const KOSONG: UnitJourneyEnvelope = {
  segments: [],
  source: "register_fallback",
  truncated: false,
  warnings: []
};

class UnitJourney {
  async forRegister(register: string | number): Promise<UnitJourneyEnvelope> {
    const response = await http.getData(`/register/${register}/unit-journey`);

    return response?.data?.data ?? KOSONG;
  }
}

export default new UnitJourney();
